import { RoleNameType } from "@/@types/general";
import { ProfileType, UserType } from "@/@types/response";
import { impersonate, profile, stop_impersonate } from "@/libs/auth";
import { showToast } from "@/utils/alert";
import { signIn } from "next-auth/react";
import { create } from "zustand";

interface AuthType {
  email: string;
  setSubscriberId: (id: string) => void;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  profile: Partial<ProfileType | null>;
  role: RoleNameType | null;
  getProfile: () => Promise<boolean | string>;
  setProfile: (user: UserType) => void;
  getPermission: (key: string) => string | null;
  impersonate: (email: string) => Promise<boolean>;
  is_impersonating: boolean;

  stopImpersonate: (email: string) => Promise<boolean>;
  subscribeId: string;
  signOut: () => void;
}
export const useAuthStore = create<AuthType>((set, get) => ({
  setSubscriberId(id) {
    set(() => ({ subscribeId: id }));
  },
  subscribeId: "",
  signOut() {
    set(() => ({ role: null, profile: null }));
  },
  getPermission(key: string) {
    const permissions = get().profile?.user?.permissions || [];
    const permission = permissions.find((i) => i == key);
    const isEligible = permission || null;
    return isEligible;
  },
  email: "",
  setEmail(email) {
    set(() => ({ email }));
  },
  password: "",
  setPassword(password) {
    set(() => ({ password }));
  },
  is_impersonating: false,
  role: null,
  profile: null,
  setProfile(user) {
    set(() => ({
      profile: { user },
      role: user?.role_names[0],
    }));
  },
  async impersonate(email: string) {
    const result = await impersonate(email!);
    if (!result.meta.success) {
      showToast({ title: result.meta.message, icon: "error" });
      return false;
    }
    localStorage.setItem("impersonate", `${get().profile?.user?.email}`);
    const res = await signIn("credentials", {
      redirect: false,
      token: JSON.stringify({ ...result.data, is_impersonate: true }),
    }).then(async (res) => {
      if (res?.ok) {
        await get().getProfile();
        showToast({ title: result.meta.message, icon: "success" });
        set(() => ({ is_impersonating: true }));
      } else {
        showToast({
          title: result.meta.message || "Terjadi Kesalahan impersonate",
          icon: "error",
        });
      }
      return res?.ok;
    });
    return res!;
  },
  async stopImpersonate(email: string) {
    const result = await stop_impersonate(email!);
    if (!result.meta.success) {
      showToast({ title: result.meta.message, icon: "error" });
      return false;
    }
    const res = await signIn("credentials", {
      redirect: false,
      token: JSON.stringify({ ...result.data }),
    }).then(async (res) => {
      if (res?.ok) {
        localStorage.removeItem("impersonate");
        await get().getProfile();
        showToast({ title: result.meta.message, icon: "success" });
        set(() => ({ is_impersonating: false }));
      } else {
        showToast({
          title: result.meta.message || "Terjadi Kesalahan impersonate",
          icon: "error",
        });
      }
      return res?.ok;
    });
    return res!;
  },
  async getProfile() {
    const result = await profile();
    if (result.meta.success) {
      // fetch user profile here
      set(() => ({
        profile: { ...result.data },
        role: result.data?.user?.role_names[0],
      }));
      return result.meta.success;
    }
    return result.meta.message;
  },
}));
